@if (formFieldSignal(); as formField) {
    <bizz-editor #editor class="min-w-full max-w-full"
                 [value]="formControl.value"
                 (valueChange)="setValue($event)"
                 (onBlur)="submitValue()"
                 [id]="formId + formField.Bookmark"
                 [hideToolbar]="!formField.ShowHTMLEditor || readOnlyOverride || formField.IsReadOnly"
                 [readOnly]="readOnlyOverride || formField.IsReadOnly"
                 [minimumHeight]="editorHeight"
                 [isError]="errorState?.AiValidationError === undefined && errorState != null"
                 [isAiError]="!formField.aiGeneration?.confirmed && formField.aiGeneration?.generated && errorState != null && errorState.AiValidationError"
                 [overflowToolbar]="!isInGrid">
    </bizz-editor>
}